export const WeeklyPlanData = [
  {
    path: "https://drive.google.com/file/d/1Chfw9aaULF0xGxCw1gqq5EOX8RlECuQ3/view",
    title: `Week 1`,
    weekNumber: '1',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1ntK1XHE0Z9tiPntBxRLVDQGUVOTUVsf6/view",
    title: `Week 2`,
    weekNumber: '2',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1mWAYNPZ9U8N2Kw-zMjhZ8RQ7-zTCoCph/view",
    title: `Week 3`,
    weekNumber: '3',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/19lOb5ytdrRmnPIFEU7PG7AvzHkvPbvfR/view",
    title: `Week 4`,
    weekNumber: '4',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/1S3LrYBdGEA_RvAwAEwZfo0oYwPsgemoB/view",
    title: `Week 5`,
    weekNumber: '5',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  },
  {
    path: "https://drive.google.com/file/d/109jPNW-phaZaw7BKxcJcSfLH0KpJIM3a/view",
    title: `Week 6`,
    weekNumber: '6',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  },
   {
    path: "https://drive.google.com/file/d/1PWbqEgtKmvOT1QCa7sV8K18D86qIuNDp/view",
    title: `Week 7`,
    weekNumber: '7',
    thumbnail: 'https://lh3.googleusercontent.com/d/16Eot4k4ZZerwyFsZhMJayxt993X8U51v=s1000?authuser=0'
  }
]